module.exports = __webpack_public_path__ + "img/career.6f0798a5.jpeg";